import React from "react"

export default class DisabledLineItem extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      fontIcon: "ss-alert alert",
      listFontIcon: "ss-alert",
    };
  }

  render() {
    if(this.props.roomDataType == true) {
      if (this.props.data.identifier) {
        return (
          <div style={{color: 'grey'}}>{this.props.data.identifier + " (" + this.props.data.room_type_name + ")"}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></div>
        )
      } else {
        return (
          <div style={{color: 'grey'}}>{this.props.data.room_type_name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></div>
        )
      }
    }
    if(this.props.disabledRoomType == true) {
      return (
        <div style={{color: 'grey'}}>{this.props.data.name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></div>
      )
    }
    if(this.props.disabledRate == true) {
      return (
        <div style={{color: 'grey'}}>{this.props.data.code} - {this.props.data.name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></div>
      )
    }
    if(this.props.disabledRoomTypes == true) {
      return (
        <li style={{color: 'grey'}}>{this.props.data.name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></li>
      )
    }
    if(this.props.disabledOveriddenPrice == true) {
      return (
        <li key={this.props.id} style={{color: 'grey'}}>{this.props.room_type_name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></li>
      )
    }
    if(this.props.disabledRates == true) {
      return (
        <li key={this.props.id} style={{color: 'grey'}}>{this.props.code} - {this.props.name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></li>
      )
    }
    if(this.props.disabledProducts == true) {
      return (
        <li key={this.props.id} style={{color: 'grey'}}>{this.props.name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></li>
      )
    }
    if(this.props.unconfirmed_email == true) {
      return (
        <div style={{color: 'grey'}}>{this.props.data}<span className={this.state.fontIcon} title={I18n.t('email_not_confirmed')}></span></div>
      )
    }
    if(this.props.disabledRoomGroupRoomType == true) {
      return (
        <li key={this.props.id}>{`${this.props.identifier} (`} {<span style={{color: 'grey'}}>{this.props.room_type_name}</span>} <span className={this.state.listFontIcon}  style={{color: 'grey'}} title={I18n.t('room_type_is_disabled')}></span> {`)`}</li>
      )
    }
    if(this.props.disabledProductTax == true) {
      return(
        <li key={this.props.id} style={{color: 'grey'}}>{this.props.name}<span className={this.state.fontIcon} title={I18n.t('status_is_disabled')}></span></li>
      )
    }
  }
  
}
